"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestApiContext = void 0;
var BasicStorage_1 = require("../../model/storage/BasicStorage");
var TestApiContext = /** @class */ (function () {
    function TestApiContext() {
        this.storage = new BasicStorage_1.BasicStorage();
    }
    TestApiContext.prototype.getWebStorage = function () {
        return this.storage;
    };
    TestApiContext.prototype.getCurrentUser = function () {
        throw new Error('Method not implemented.');
    };
    TestApiContext.prototype.isUserLoggedIn = function () {
        throw new Error('Method not implemented.');
    };
    TestApiContext.prototype.getSiteToken = function () {
        throw new Error('Method not implemented.');
    };
    TestApiContext.prototype.getAppDefinitionId = function () {
        throw new Error('Method not implemented.');
    };
    TestApiContext.prototype.experimentEnabled = function (key) {
        throw new Error('Method not implemented.');
    };
    TestApiContext.prototype.getHTTPClient = function () {
        return this.httpClient;
    };
    TestApiContext.prototype.setHTTPClient = function (client) {
        this.httpClient = client;
    };
    return TestApiContext;
}());
exports.TestApiContext = TestApiContext;
//# sourceMappingURL=TestApiContext.js.map